import {
  MOBILE_RESERVATION_CART_SUMMARY_VISIBLE,
  MOBILE_RESERVATION_CART_SUMMARY_NOT_VISIBLE,
  UPDATE_RESERVATION_CART_REQUEST,
  GET_RESERVATION_CART_REQUEST,
  CREATE_RESERVATION_CART_REQUEST,
  // UPDATE_AND_PROCESS_RESERVATION_CART_REQUEST,
  PROCESS_RESERVATION_CART_REQUEST,
  PROCESS_PAY_STACK_RESERVATION_CART_UP_REQUEST,
  ADD_RESERVATION_CART_COUPON_REQUEST,
  CREATE_RESERVATION_CART_CUSTOMER_AND_SETUP_INTENT_REQUEST
  // RESERVATION_CHECKOUT_STEP_REQUEST
} from './constants';

export const showMobileSummary = () => ({
  type: MOBILE_RESERVATION_CART_SUMMARY_VISIBLE
});

export const hideMobileSummary = () => ({
  type: MOBILE_RESERVATION_CART_SUMMARY_NOT_VISIBLE
});

export const addCoupon = (couponCode, onSuccess, onError) => ({
  type: ADD_RESERVATION_CART_COUPON_REQUEST,
  couponCode,
  onSuccess,
  onError
});

export const createReservationCart = (reservationCart, onSuccess) => ({
  type: CREATE_RESERVATION_CART_REQUEST,
  reservationCart,
  onSuccess
});

export const getReservationCart = () => ({
  type: GET_RESERVATION_CART_REQUEST
});

export const updateReservationCart = (reservationCart, onSuccess, onError) => ({
  type: UPDATE_RESERVATION_CART_REQUEST,
  reservationCart,
  onSuccess,
  onError
});

export const processReservationCart = (onSuccess, onError) => ({
  type: PROCESS_RESERVATION_CART_REQUEST,
  onSuccess,
  onError
});

export const processPaystack = (tenderId, onSuccess, onError) => ({
  type: PROCESS_PAY_STACK_RESERVATION_CART_UP_REQUEST,
  tenderId,
  onSuccess,
  onError
});

export const createStripeCustomerAndSetupIntent = (
  customerPayload,
  onSuccess,
  onError
) => ({
  type: CREATE_RESERVATION_CART_CUSTOMER_AND_SETUP_INTENT_REQUEST,
  customerPayload,
  onSuccess,
  onError
});
